<template>
    <div>
        <ModalCommon :id="`configModalActionProduct-${config?.id ?? ''}`" :config="config" @save="handleSave()" @close="handleClose()">
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" for="adsfasđs" style="min-width: 80px"
                    >{{ $t('landingPage.settingTargetProduct.titleTargetProduct') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-11">
                    <InputText
                        :model.sync="dataFormProd.title"
                        :config.sync="configFormProductLP.configFieldTitleProduct"
                        @blur="handleValidateField(configFormProductLP.configFieldTitleProduct)"
                    />
                    <div class="mt-3">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                            <div class="col-sm-3">
                                <div class="d-flex align-items-center" style="gap: 0.5rem">
                                    <InputText
                                        style="max-width: 120px"
                                        :model.sync="dataFormProd.size_product"
                                        :config.sync="configFormProductLP.configFieldSizeTitle"
                                    />
                                    <span>px</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="dataFormProd.color_product"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="dataFormProd.color_product"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="dataFormProd.background_product"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="dataFormProd.background_product"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" for="adsfasđs" style="min-width: 80px"
                    >{{ $t('landingPage.settingTargetProduct.imageTargetProduct') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-11">
                    <UploadImageCommon
                        :fileValues.sync="dataFormProd.image"
                        @dataFile="handleFileBackgroundEditor"
                        :id="`ImgTitlePrize`"
                        :config="{
                            maxSize: 2048
                        }"
                    >
                        <template #warning>
                            <div style="font-size: 13px">
                                {{ $t('noteUploadMaxMB') }}
                            </div>
                        </template>
                    </UploadImageCommon>
                    <div v-if="isRequiredImage" class="invalid-feedback d-block">
                        {{
                            $t('validateField.requiredSelect', {
                                field: $t('landingPage.settingTargetProduct.imageTargetProduct')
                            })
                        }}
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.backgroundItem') }}</label>
                <div class="col-sm-5">
                    <div class="d-flex" style="gap: 1rem">
                        <InputText
                            style="min-width: 100px"
                            :model.sync="dataFormProd.background_item"
                            :config="{
                                type: 'color',
                                classCustom: 'form-control-color',
                                error: false
                            }"
                        />
                        <InputText
                            style="max-width: 100px"
                            :model.sync="dataFormProd.background_item"
                            :config="{
                                error: false
                            }"
                        />
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.settingTargetProduct.status') }} </label>
                <div class="col-sm-11">
                    <div class="d-flex">
                        <div v-for="item in STATUS_TARGET_PRODUCT" :key="item.id + 's'">
                            <InputRadio
                                class="mr-4"
                                :model.sync="dataFormProd.status"
                                :name="`statusTitlePrize`"
                                :id="`statusTitlePrize-${item.id}`"
                                :value="item.value"
                                :label="item.name"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.settingTargetProduct.detailTargetProduct') }} </label>
                <div class="col-sm-11">
                    <Editor
                        v-if="isVisibleEditor"
                        :id="`configModalActionProduct-${config?.id ?? ''}`"
                        :model.sync="dataFormProd.detail"
                        :modelEvents="`change keydown blur focus paste`"
                        :configInit="configEditor"
                        @init="onEditorInit"
                    />
                </div>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import { InputText, InputRadio } from '@/components/Input';
import { configFormProductLP, STATUS_TARGET_PRODUCT } from './constants';
import { validateField, validateAllField } from '@/utils/validate';
import { IMAGE_EXTENSIONS } from '@/utils/format';

import ModalCommon from '@/components/Modal/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'ModalEditProduct',
    components: {
        InputText,
        ModalCommon,
        UploadImageCommon,
        Editor,
        InputRadio
    },
    props: {
        config: {
            type: Object,
            required: true,
            default: () => null
        },
        dataProducts: {
            type: Array,
            default: () => []
        },
        objProduct: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            STATUS_TARGET_PRODUCT: STATUS_TARGET_PRODUCT,
            configFormProductLP: configFormProductLP,
            dataFormProd: this.initTargetProduct(),
            arrExtension: IMAGE_EXTENSIONS,
            isVisibleEditor: false,
            isRequiredImage: false,
            objEditor: null,
            configEditor: {
                height: 600
            }
        };
    },
    methods: {
        initTargetProduct() {
            return {
                make_id: this.onHandleMakeId(this.dataProducts),
                title: '',
                size_product: '20',
                color_product: '',
                background_product: '',
                background_item: '',
                image: null,
                detail: '',
                status: true
            };
        },

        onHandleMakeId(arrP) {
            if (!arrP || arrP?.length <= 0) return arrP.length + 1;
            const numbers = arrP.map((oarr) => oarr.make_id);
            return Math.max(...numbers) + 1;
        },
        handleValidateField(configField) {
            validateField(configField);
        },

        handleSave() {
            let checkValidate = validateAllField(configFormProductLP);
            this.isRequiredImage = !this.dataFormProd.image;
            if (!checkValidate || this.isRequiredImage) return;
            this.$emit('saveDataProd', this.dataFormProd);
            this.config.model = false;
        },

        handleClose() {
            let { configFieldTitleProduct } = this.configFormProductLP;
            configFieldTitleProduct.error = false;
            this.config.model = false;
        },

        handleFileBackgroundEditor() {
            this.isRequiredImage = false;
        },

        onEditorInit(editor) {
            this.objEditor = editor;
        }
    },
    watch: {
        'config.model': {
            handler: function (newShow) {
                if (newShow) {
                    const foundObj = this.dataProducts?.find((opd) => opd.make_id === this.objProduct?.make_id);
                    if (foundObj) {
                        this.dataFormProd = {
                            ...this.dataFormProd,
                            ...foundObj,
                            size_product: foundObj.size_product || '20'
                        };
                    }
                    setTimeout(() => {
                        this.isVisibleEditor = true;
                    }, 200);
                } else {
                    this.isVisibleEditor = false;
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
